export enum OutboundFlowRoutes {
  DESTINATION = 'destination',
  DATES = 'outbound-dates',
  TRAVELERS = 'outbound-travelers',
  CONTACTS = 'outbound-contacts',
  SELECT_PLANS = 'outbound-select-plans',
  PERSONAL_INFORMATION = 'outbound-personal-information',
  INSURED_TRAVELERS = 'outbound-insured-travelers',
  QUOTE = 'outbound-quote',
  INSURANCE_RESULT = 'outbound-insurance-result',
}

export enum InboundFlowRoutes {
  RESIDENCE = 'residence',
  DATES = 'inbound-dates',
  TRAVELERS = 'inbound-travelers',
  CONTACTS = 'inbound-contacts',
  SELECT_PLANS = 'inbound-select-plans',
  PERSONAL_INFORMATION = 'inbound-personal-information',
  INSURED_TRAVELERS = 'inbound-insured-travelers',
  QUOTE = 'inbound-quote',
  INSURANCE_RESULT = 'inbound-insurance-result',
}

export enum GeneralRoutes {
  INSURANCE_RESULT = 'insurance-result',
  NOT_FOUND = 'NotFound',
  NOT_FOUND_404 = 'NotFound404',
}

export enum LandingsRoutes {
  TRAVEL_MAIN = 'travel-insurance',
}

export type AvailabelRoutes =
  | OutboundFlowRoutes
  | InboundFlowRoutes
  | GeneralRoutes
  | LandingsRoutes
